export const TeamChatMessageTestIds = {
  MORE_ACTIONS_BUTTON: 'team-chat.message-actions-button',
  EDIT_INPUT: 'team-chat.message-edit-input',
  EDIT_CANCEL_BUTTON: 'team-chat.message-edit-cancel-button',
  EDIT_SAVE_BUTTON: 'team-chat.message-edit-save-button',
};
